import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
// import qs from 'qs'

Vue.use(Router)

let pageSource = localStorage.getItem('school_source') // 标注版本 新版
// 正式环境
export const baseURL = pageSource === 'v2' ? 'https://wxschool.5idream.net/v2/api/' : 'https://manager.5idream.net/api/'
// 测试环境
// export const baseURL = pageSource === 'v2' ? '/v2/api' : '/api/api'
const Axios = axios.create({
  baseURL: baseURL,
  timeout: 1000000,
  responseType: 'json',
  withCredentials: true, // 是否允许带cookie
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(
  config => {
    // Vue.$vux.loading.show({
    //   text: ''
    // })
    // 在发送请求之前做某件事
    if (
      config.method === 'post'
    ) {
      // 序列化
      // config.data = qs.stringify(config.data, { arrayFormat: 'brackets' })
    }
    return config
  },
  error => {
    Vue.$vux.toast.show({
      type: 'warn',
      text: '网络异常'
    })
    return Promise.reject(error.data)
  }
)

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    Vue.$vux.loading.hide()
    if (+res.data.code === -1005) {
      window.location.href = '/h5/'
    } else if (+res.data.code === -1004) {
      window.location.href = '/h5/schoollist?backurl=' + window.location.href + '&type=1'
    } else {
      if (res.data.code && +res.data.code !== 100) {
        if (+res.data.code !== -1003 && +res.data.code !== 401) {
          if (+res.data.code === -2000) {
            Vue.$vux.toast.show({
              type: 'warn',
              text: res.data.msg
            })
          } else {
            Vue.$vux.toast.show({
              type: 'warn',
              text: res.data.msg || res.data.result.msg || res.data.result
            })
          }
        }
      }
      return res.data
    }
    return res.data
  },
  error => {
    Vue.$vux.loading.hide()
    Vue.$vux.toast.show({
      type: 'warn',
      text: '网络异常，请求超时'
    })
    return Promise.reject(error)
  }
)

// 动态修改基础路径的方法
function setBaseURL (newBaseURL) {
  Axios.defaults.baseURL = newBaseURL
}

Vue.prototype.$setBaseURL = setBaseURL

// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
  install: function (Vue, Option) {
    Object.defineProperty(Vue.prototype, '$http', {
      value: Axios
    })
  }
}



// WEBPACK FOOTER //
// ./src/server/index.js